import { actionTypes } from './constants';

const initialState = {
  total: 0,
  searchCondition: {},
  list: [],
  state: '',
  infoEditingList: {},
  classList: [],
  classEditingList: {},
  addClassVisible: false,
  currentGroup: null,
};
function handleSetQuotationClassList(state, action) {
  const classEditingList = state.classEditingList;
  const classEditingListTemp = {};
  action.data.map(item => classEditingListTemp[item.id] = classEditingList[item.id]);
  return { ...state, classList: action.data, classEditingList: classEditingListTemp };
}
function handleToggleQuotationCategoryEditing(state, action) {
  const classEditingListTemp = Object.assign({}, state.classEditingList);
  const id = action.data.id;
  classEditingListTemp[id] = !classEditingListTemp[id];
  return { ...state, classEditingList: classEditingListTemp };
}
function handleSetQuotationList(state, action) {
  const infoEditingList = state.infoEditingList;
  const infoEditingListTemp = {};
  action.data.rows.map(item => infoEditingListTemp[item.id] = infoEditingList[item.id]);
  return { ...state, list: action.data.rows, total: action.data.total, infoEditingList: infoEditingListTemp};
}

function handleToggleQuotationInfoCategoryEditing(state, action) {
  const infoEditingListTemp = Object.assign({}, state.infoEditingList);
  const id = action.data.id;
  infoEditingListTemp[id] = !infoEditingListTemp[id];
  return { ...state, infoEditingList: infoEditingListTemp };
}
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case actionTypes.INIT_QUOTATION_TABLE: 
      return { ...initialState };
    case actionTypes.SET_QUOTATION_CLASS_LIST:
      return handleSetQuotationClassList(state, action);
    case actionTypes.TOGGLE_QUOTATION_CATEGORY_EDITING:
      return handleToggleQuotationCategoryEditing(state, action);
    case actionTypes.SET_QUOTATION_CLASS_ADD_VISIBLE:
      return { ...state, addClassVisible: action.data };
    case actionTypes.SET_QUOTATION_SEARCH_CONDITION:
      return { ...state, searchCondition: action.data, page:1 };
    case actionTypes.SET_QUOTATION_LIST:
      return handleSetQuotationList(state, action);
    case actionTypes.SET_QUOTATION_LIST_PAGE:
      return { ...state, page: action.data.page };
    case actionTypes.TOGGLE_QUOTATION_INFO_CATEGORY_EDITING:
      return handleToggleQuotationInfoCategoryEditing(state, action);
    case actionTypes.SET_CURRENT_PRODUCT_GROUP:
      return { ...state, currentGroup: action.data };
    default:
      return state;
  }
};